import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';


const TermsOfUse = () => {
    const { language } = useLanguage();

    return (
        <>
            <SEO title={Features.TERMS_PAGE.TITLE[language]} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title={Features.TERMS_PAGE.BREADCRUMB_TITLE[language]}
                page={Features.TERMS_PAGE.TITLE[language]}
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                    <div className="section-title" style={{marginBottom: '30px'}}>
                                        <h5 className="title">{language === 'pt' ? 'Termos e Condições de Utilização — fielcarga.pt' : 'Terms and Conditions of Use — fielcarga.pt'}</h5>
                                    </div>
                                    
                                    <p>
                                        {language === 'pt' 
                                            ? 'O presente documento regula as condições de utilização do website fielcarga.pt, propriedade da FieltransCarga Unipessoal, Lda., pessoa coletiva n.º 515882623, com sede na Rua Dom Afonso Henriques, n.º 1539, 4425-636 Pedrouços – Maia.'
                                            : 'This document regulates the conditions of use of the website fielcarga.pt, owned by FieltransCarga Unipessoal, Lda., legal entity no. 515882623, with headquarters at Rua Dom Afonso Henriques, no. 1539, 4425-636 Pedrouços – Maia.'
                                        }
                                    </p>
                                    <p>
                                        {language === 'pt'
                                            ? 'A FieltransCarga Unipessoal, Lda. encontra-se legalmente habilitada para o exercício da sua atividade, sendo titular do Alvará n.º 669921, emitido pela entidade competente, o Instituto da Mobilidade e dos Transportes (IMT).'
                                            : 'FieltransCarga Unipessoal, Lda. is legally authorized to carry out its activity, being the holder of License No. 669921, issued by the competent entity, the Institute for Mobility and Transport (IMT).'
                                        }
                                    </p>
                                    <p>
                                        Ao aceder e utilizar este website, o utilizador aceita, de forma expressa e sem reservas, os presentes Termos e Condições.
                                    </p>

                                    <h4>1) Objeto do website</h4>
                                    <p>
                                        O website fielcarga.pt tem como finalidade disponibilizar informação institucional sobre a atividade da FieltransCarga Unipessoal Lda., bem como permitir o contacto por parte dos utilizadores para pedido de informações ou orçamentos.
                                    </p>
                                    <p>
                                        A utilização do website não constitui, por si só, qualquer relação contratual entre o utilizador e a FieltransCarga.
                                    </p>

                                    <h4>2) Utilização do website</h4>
                                    <p>
                                        O utilizador compromete-se a utilizar o website de forma responsável, lícita e de acordo com a legislação aplicável, abstendo-se de qualquer utilização que possa:
                                    </p>
                                    <ul>
                                        <li>comprometer a segurança, funcionamento ou integridade do website;</li>
                                        <li>infringir direitos de terceiros;</li>
                                        <li>introduzir conteúdos ilícitos, ofensivos, enganosos ou fraudulentos.</li>
                                    </ul>
                                    <p>
                                        A FieltransCarga reserva-se o direito de restringir ou impedir o acesso ao website sempre que se verifique uma utilização abusiva ou contrária à lei.
                                    </p>

                                    <h4>{language === 'pt' ? '3) Conteúdos e propriedade intelectual' : '3) Content and intellectual property'}</h4>
                                    <p>
                                        {language === 'pt'
                                            ? 'Todos os conteúdos disponibilizados neste website, incluindo textos, imagens, logótipos, marcas, elementos gráficos e layout, encontram-se protegidos por direitos de autor. Alguns conteúdos são propriedade da FieltransCarga Unipessoal, Lda., sendo outros utilizados ao abrigo de licenças válidas ou com autorização dos respetivos titulares.'
                                            : 'All content made available on this website, including texts, images, logos, trademarks, graphic elements and layout, are protected by copyright. Some content is the property of FieltransCarga Unipessoal, Lda., while others are used under valid licenses or with authorization from their respective holders.'
                                        }
                                    </p>
                                    <p>
                                        {language === 'pt'
                                            ? 'É proibida a reprodução, distribuição, modificação ou utilização dos conteúdos, no todo ou em parte, sem autorização prévia e escrita da FieltransCarga.'
                                            : 'The reproduction, distribution, modification or use of the content, in whole or in part, without prior written authorization from FieltransCarga is prohibited.'
                                        }
                                    </p>

                                    <h4>4) Responsabilidade</h4>
                                    <p>
                                        A FieltransCarga envida esforços para garantir que a informação disponibilizada no website seja correta e atualizada. No entanto, não garante a inexistência de erros, omissões ou desatualizações, nem assume qualquer responsabilidade por danos resultantes da utilização do website ou da informação nele contida.
                                    </p>
                                    <p>
                                        A FieltransCarga não se responsabiliza por eventuais interrupções, falhas técnicas ou indisponibilidades temporárias do website.
                                    </p>

                                    <h4>5) Ligações para sites de terceiros</h4>
                                    <p>
                                        O website pode conter ligações para sites de terceiros, disponibilizadas para conveniência do utilizador. A FieltransCarga não exerce qualquer controlo sobre esses sites, não assumindo responsabilidade pelos seus conteúdos, políticas ou práticas.
                                    </p>

                                    <h4>6) Proteção de dados pessoais</h4>
                                    <p>
                                        O tratamento de dados pessoais efetuado através do website é regulado pela Política de Privacidade, disponível em página própria, a qual deve ser consultada pelo utilizador.
                                    </p>

                                    <h4>7) Alterações aos Termos e Condições</h4>
                                    <p>
                                        A FieltransCarga reserva-se o direito de alterar os presentes Termos e Condições a qualquer momento, sendo as alterações publicadas no website. Recomenda-se a consulta periódica deste documento.
                                    </p>

                                    <h4>8) Lei aplicável e foro competente</h4>
                                    <p>
                                        Os presentes Termos e Condições regem-se pela lei portuguesa.
                                    </p>
                                    <p>
                                        Para a resolução de quaisquer litígios emergentes da utilização do website, é competente o foro da comarca da sede da FieltransCarga Unipessoal Lda., com expressa renúncia a qualquer outro.
                                    </p>

                                    <p style={{marginTop: '30px', fontStyle: 'italic', color: 'var(--color-body)'}}>
                                        Última atualização: 1 de janeiro de 2025.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default TermsOfUse;
